import React, { useState, useEffect } from "react";
import axios from "axios";

function App() {
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState([]);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [token, setToken] = useState(localStorage.getItem("token") || "");
    const [loginError, setLoginError] = useState("");
    const [isRegistering, setIsRegistering] = useState(false);
    const [registerError, setRegisterError] = useState("");

    useEffect(() => {
        if (token) {
            axios.get(`${process.env.REACT_APP_API_URL}/products`, {
                headers: { Authorization: `Bearer ${token}` },
            })
                .then((response) => {
                    setProducts(response.data);
                })
                .catch((error) => console.error(error));
        }
    }, [token]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const params = new URLSearchParams();
            params.append("username", username);
            params.append("password", password);

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/login`,
                params,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            );

            setToken(response.data.access_token);
            localStorage.setItem("token", response.data.access_token);
            setLoginError("");
        } catch (error) {
            setLoginError("Invalid username or password.");
            console.error("Login error:", error.response?.data || error.message);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/register`,
                {
                    username: username,
                    password: password,
                }
            );
            alert("Registration successful! You can now log in.");
            setIsRegistering(false);
            setRegisterError("");
        } catch (error) {
            setRegisterError(error.response?.data?.detail || "Registration failed.");
        }
    };

    const handleLogout = () => {
        setToken("");
        localStorage.removeItem("token");
    };

    const addToCart = (product) => {
        setCart([...cart, product]);
    };

    const removeFromCart = (productId) => {
        setCart(cart.filter((product) => product.id !== productId));
    };

    return (
        <div>
            {!token ? (
                <div>
                    <h2>{isRegistering ? "Register" : "Login"}</h2>
                    <form onSubmit={isRegistering ? handleRegister : handleLogin}>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Username"
                        />
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                        />
                        <button type="submit">{isRegistering ? "Register" : "Login"}</button>
                    </form>
                    {isRegistering && registerError && <p style={{ color: "red" }}>{registerError}</p>}
                    {!isRegistering && loginError && <p style={{ color: "red" }}>{loginError}</p>}
                    <button onClick={() => setIsRegistering(!isRegistering)}>
                        {isRegistering ? "Already have an account? Log in" : "New user? Register"}
                    </button>
                </div>
            ) : (
                <div>
                    <h2>Welcome, {username}!</h2>
                    <button onClick={handleLogout}>Logout</button>

                    <h2>Products</h2>
                    <div>
                        {products.map((product) => (
                            <div key={product.id}>
                                <h3>{product.name}</h3>
                                <p>{product.description}</p>
                                <p>${product.price}</p>
                                <button onClick={() => addToCart(product)}>Add to Cart</button>
                            </div>
                        ))}
                    </div>

                    <h2>Cart</h2>
                    <div>
                        {cart.length === 0 ? (
                            <p>Your cart is empty.</p>
                        ) : (
                            cart.map((product) => (
                                <div key={product.id}>
                                    <p>{product.name} - ${product.price}</p>
                                    <button onClick={() => removeFromCart(product.id)}>Remove</button>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default App;
